import templateUrl from "emun.invoice/invoice-list-grid.htm";

export default () => ({ templateUrl });